module.exports = __webpack_public_path__ + "static/media/cebolas.741f2d3a.jpg";